import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

import { analyticsReducer } from './analytics';
import { authReducer } from './auth';
import { brandReducer } from './brand';
import { uiReducer } from './ui';
import { campaignReducer } from './campaign/campaign';
import { sponsorshipSetReducer } from './campaign/sponsorshipSet';
import { sponsorshipReducer } from './campaign/sponsorship';
import { summaryReducer } from './campaign/summary';
import { manageReducer } from './manage';
import { eightAuth } from './eightauth';
import { dataReducer } from './data/reducer';

export const createRootReducer = (history) =>
  combineReducers({
    analytics: analyticsReducer,
    auth: authReducer,
    brand: brandReducer,
    campaign: campaignReducer,
    sponsorshipSet: sponsorshipSetReducer,
    sponsorship: sponsorshipReducer,
    summary: summaryReducer,
    manage: manageReducer,
    data: dataReducer,
    ui: uiReducer,

    router: connectRouter(history),

    ...eightAuth.authReducer,
  });
